import React from 'react';
import PageNotFound from './defaultPages/pageNotFound';

const WhenNotFound = () => <PageNotFound />;

export default WhenNotFound;
